import { render, staticRenderFns } from "./NavigationLink.vue?vue&type=template&id=2ffa8bfe&scoped=true"
import script from "./NavigationLink.vue?vue&type=script&lang=ts"
export * from "./NavigationLink.vue?vue&type=script&lang=ts"
import style0 from "./NavigationLink.vue?vue&type=style&index=0&id=2ffa8bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa8bfe",
  null
  
)

export default component.exports